//src/design-system/Molecules/VideoPlayerModel/index.tsx

import React from "react";
import { Modal } from "@/design-system/Atoms/Modal";
import { Button } from "@/design-system/Atoms";
import type { Video } from "@/rtkQuery/features/models/video.model";
import { useVideoService } from "@/rtkQuery/features/hooks/useVideoService";
import videoThumbnailMap, { DEFAULT_THUMBNAIL } from "@/constants/videoThumbnailMap";

interface VideoPlayerModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: Video;
  onAcknowledged?: () => Promise<void> | void;
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  isOpen,
  onClose,
  content,
  onAcknowledged,
}) => {
  const { confirmVideoWatched, videosIsConfirming } = useVideoService();

  const handleAcknowledge = async () => {
    await confirmVideoWatched(content.Id);

     if (onAcknowledged) {
       await onAcknowledged();
     }
     onClose();
  };

  const getThumbnail = (): string => {
    const title =
      content.VideoName || content.FileName.replace(/\.[^/.]+$/, "");
    const thumbnail = videoThumbnailMap[title];
    return `/images/video-thumbnail/${thumbnail || DEFAULT_THUMBNAIL}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={content.VideoName || content.FileName.replace(/\.[^/.]+$/, "")}
      size="xl"
      className="max-h-screen"
      childrenClassName="max-h-[calc(100vh-120px)]"
    >
      <div className="p-6">
        <div className="relative prose prose-sm max-w-none">
          <video
            className="w-full h-auto rounded-lg shadow-lg"
            controls
            src={content.Url}
            poster={getThumbnail()}
          />
          <div className="flex justify-end">
            <Button
              variant="graySubmitButton"
              size="xl"
              type="button"
              onClick={handleAcknowledge}
              disabled={videosIsConfirming || content.WasWatched}
            >
              {content.WasWatched
                ? "Already Acknowledged"
                : videosIsConfirming
                  ? "Marking as watched..."
                  : "I acknowledge that I've watched this video."}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VideoPlayerModal;